import React, { Component } from 'react';
import { message, Table, Modal } from 'antd';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import TransfiniteModal from '../../sumTotal/TransfiniteModal';
import Filter from './Filter';
import AcLog from '../../sumTotal/projectPercent/AcLog';

class Transfinite extends Component {
    state = {
        searchParams: {},
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
            showTotal: total => <span style={{ color: "#108ee9" }}>总计{total}条记录，每页10条</span>
        },
        loading: false,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.sumtotal.querytInvestigationFinishThreshold,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    search = (searchParams = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, pagination } = this.state;
        ExportUtil.export(searchParams, pagination, API_URL.sumtotal.exportInvestigationFinishThreshold);
    }

    getColumns = () => {
        const columns = [
            {
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: 'JDE主项目号',
                dataIndex: 'jdeCode',
                key: 'jdeCode',
                width: 100,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 200,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 120,
            }, {
                title: '项目阶段',
                dataIndex: 'stageNames',
                key: 'stageNames',
                width: 90,
            }, {
                title: '计收入确认方式',
                dataIndex: 'contractTypeName',
                key: 'contractTypeName',
                width: 80,
            }, {
                title: 'PM工号',
                dataIndex: 'investigationPmEmployeeCode',
                key: 'investigationPmEmployeeCode',
                width: 80,
            }, {
                title: 'PM姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
            }, {
                title: '上月total1',
                dataIndex: 'lastTotal',
                key: 'lastTotal',
                width: 80,
            }, {
                title: '上月total1/合同FTE数',
                dataIndex: 'lastFtePresent',
                key: 'lastFtePresent',
                width: 80,
                render: (text) => {
                    return `${text ? `${text}%` : ''}`;
                }
            }, {
                title: '本月total1',
                dataIndex: 'thisMonthTotalFte',
                key: 'thisMonthTotalFte',
                width: 80,
            }, {
                title: '本月total1/合同FTE数',
                dataIndex: 'thisMonthFtePresent',
                key: 'thisMonthFtePresent',
                width: 80,
                render: (text) => {
                    return `${text ? `${text}%` : ''}`;
                }
            }
        ];
        const { curRole } = sessionStorage;
        if (curRole !== 'PM') {
            columns.push({
                title: 'AC自动调整功能',
                dataIndex: 'acStatus',
                key: 'acStatus',
                width: 80,
                render: (text) => {
                    return text === 'CLOSE' ? '已关闭' : '已开启';
                }
            });
        }
        columns.push({
            title: '超限阀值',
            dataIndex: 'thresholdValue',
            key: 'thresholdValue',
            width: 80,
            render: (text) => {
                return `${text ? `${text}%` : ''}`;
            }
        }, {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            // fixed: 'right',
            width: 90,
            render: (text, record) => {
                const { acStatus, investigationId } = record;
                return (
                    (curRole !== 'PM' && curRole !== 'PML') ?
                        <span>
                            <a onClick={() => this.transfinite(investigationId || 0)}>设置超限阀值</a>
                            <span className="ant-divider" />
                            <a onClick={() => this.acLog(investigationId || 0 ,acStatus=='OPEN' ? 'CLOSE' : 'OPEN' )}>
                                {acStatus === "CLOSE" ? '开启AC' : '关闭AC'}
                            </a>
                        </span>
                        :
                        <a onClick={() => this.transfinite(investigationId || 0)}>发送超限申请</a>
                )
            }
        })
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = (data || []).map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    transfinite = (investigationId) => {
        this.transfiniteModalRef.show(investigationId);
    }

    back = () => {
        this.props.showTransfinite(false);
    }

    acLog = (investigationId,opStatus) => {
        this.acLogRef.show(investigationId,opStatus);
    }

    render() {
        const { curRole } = sessionStorage
        const { loading, pagination } = this.state;
        const xscroll = curRole !== 'PM' ? 1380 : 1300;
        return (
            <div className="full home">
                <div>
                    <p className="TransfiniteTitle">{curRole === "BO" ? '超限管理' : '超限申请'}</p>
                    <Filter
                        back={this.back}
                        search={this.search}
                        export={this.export}
                        showTransfinite={() => this.props.showTransfinite(false)}
                    />
                    <div className="content-2">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.investigationId}
                            loading={loading}
                            scroll={{ x: xscroll }}
                            onChange={this.handleTableChange}
                            pagination={pagination}
                        />
                    </div>
                    <TransfiniteModal
                        loadData={this.loadData}
                        ref={el => this.transfiniteModalRef = el}
                    />
                </div>
                <AcLog ref={el => { this.acLogRef = el }} loadData={this.loadData} nowAcStatus={() => { }} />
            </div>
        );
    }
}

export default Transfinite;


// WEBPACK FOOTER //
// ./src/components/investigation/transfinite/index.js